import { useState, useEffect, useMemo } from "react";
import { useRouter } from 'next/router';
export interface Opt {
  propsConfig: Record<string, any>;
}

const useRootAppConfig = (options: Opt) => {

  const { propsConfig } = options || {};

  const router = useRouter();

  const [theme, setTheme] = useState();
  const [antdToken, setAntdToken] = useState();
  const [deviceInfo, setDeviceInfo] = useState();
  const [omsConfig, setOmsConfig] = useState();

  const appConfig = useMemo(() => {  
    return {
      theme: propsConfig?.theme || theme,
      antdToken: propsConfig?.antdToken || antdToken,
      deviceInfo: propsConfig?.deviceInfo || deviceInfo,
      omsConfig: propsConfig?.omsConfig || omsConfig,
    }
  }, [theme, antdToken, deviceInfo, omsConfig, propsConfig])
  
  useEffect(() => {
    if (propsConfig?.theme) {
      setTheme(propsConfig?.theme);
    }

    if (propsConfig?.antdToken) {
      setAntdToken(propsConfig?.antdToken);
    }
      
    if (propsConfig?.deviceInfo) {
      setDeviceInfo(propsConfig?.deviceInfo);
    }

    if (propsConfig?.omsConfig) {
      setOmsConfig(propsConfig?.omsConfig);
    }

  }, [propsConfig])


useEffect(() => {
  // getClientAppConfig();
}, [])

  // useEffect(() => {
  //   // router.replace('/302')
  //   if (!appConfig.omsConfig || !appConfig.theme) {
  //     getClientAppConfig();
  //   }
  // }, [appConfig.omsConfig, appConfig.theme])
 
  return appConfig;
}

export default useRootAppConfig;